<script>
    import "$lib/scss/main.scss";
    import Header from "../components/ui/Header.svelte";
    import Footer from "../components/ui/Footer.svelte";
    import MobileMenu from "../components/ui/MobileMenu.svelte";
    import { page } from "$app/stores";
    import Cookies from "/src/components/ui/Cookies.svelte";
    import { t, locale } from "$lib/translations";
    import { onMount } from "svelte";
    import { goto } from "$app/navigation";

    let navLinks = [];
    let isAdminPage = false;
    let excludeLayout = false;
    let excludeHeader = false;

    $: if ($t && $locale) {
        navLinks = [
            { name: $t("header.main"), endpoint: `/${$locale}`, blank: false },
            { name: $t("header.news"), endpoint: `/${$locale}/news`, blank: false },
            {
                name: $t("header.forum"),
                endpoint:
                    $locale === "en" || $locale === "ua"
                        ? "https://forum.unrealrp.com.ua/"
                        : "https://ge-forum.unrealrp.com/",
                blank: true,
            },
            { name: $t("header.radio"), endpoint: "https://radio.unrealrp.com.ua/public/unreal_rp", blank: true },
            { name: $t("header.shop"), endpoint: "/shop" },
        ];
    }

    $: {
        const currentPath = $page.url.pathname;
        isAdminPage = currentPath === "/admin";
        excludeLayout =
            currentPath.includes("/donate-in-game") ||
            currentPath.includes("/game-purchase") ||
            currentPath.includes("/user-agreement-in-game") ||
            currentPath.includes("/gang-land");
        excludeHeader = currentPath.includes("/gang-land");

        if (typeof document !== "undefined" && document.body) {
            if (
                currentPath.includes("/how-to-play") ||
                currentPath.includes("/donate-in-game") ||
                currentPath.includes("/game-purchase") ||
                currentPath.includes("/user-agreement-in-game")
            ) {
                document.body.classList.add("grey");
            } else if (currentPath.includes("/gang-land")) {
                document.body.classList.add("gang-land");
            } else {
                document.body.classList.remove("grey");
                document.body.classList.remove("gang-land");
            }
        }
    }

    onMount(() => {
        const params = new URLSearchParams(window.location.search);
        const utmKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid"];

        for (const key of utmKeys) {
            const value = params.get(key);
            if (value) {
                const cookies = document.cookie.split("; ").reduce((acc, pair) => {
                    const [k, v] = pair.split("=");
                    acc[k] = v;
                    return acc;
                }, {});

                const current = cookies[key];
                if (current !== encodeURIComponent(value)) {
                    document.cookie = `${key}=${encodeURIComponent(value)}; path=/; max-age=2592000; SameSite=Lax; Secure`;
                }
            }
        }
    });

    // $: ({ route } = $page.data);
</script>

<!--<svelte:head>-->
<!--	<link rel="alternate" hreflang="{$locale}" href={`https://unrealrp.com${$page.url.pathname}`} />-->
<!--</svelte:head>-->

<!--<select on:change="{({ target }) => goto(target.value)}">-->
<!--	{#each $locales as lc}-->
<!--		<option value="/{lc}{route}" selected="{lc === $locale}">{$t(`lang.${lc}`)}</option>-->
<!--	{/each}-->
<!--</select>-->

{#if !excludeLayout}
    <Cookies />
    <MobileMenu {navLinks} />
{/if}
{#if !excludeHeader}
    <Header {navLinks} />
{/if}

<main class:admin={isAdminPage}>
    <slot />
</main>

{#if !excludeLayout}
    <Footer />
{/if}
